module.exports = "<div class=\"list-empty\">\n  <span class=\"icon-warning\"></span>\n  <span>{{'GLOBALS.NOT_ALLOWED' | translate}}</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/features/notAllowed/notAllowed.html
// module id = 1060
// module chunks = 0